export default {
  reportDataRange: 'Report Data Range: ',
  scanInfo: 'Scan Info',
  tunnelMachine: 'Tunnel Machine',
  cartonQty: 'Carton Qty',
  rfidQty: 'RFID Qty',
  dataTransferInfo: 'Data Transfer Info',
  api: 'API',
  noReadQty: 'No Read Qty*',
  noDataQty: 'No Data Qty**',
  dataMissing: 'Data Missing***',
  noRead: '*No Read: no carton number',
  noData: '**No Data: no EPC',
  dtMissing: '***Data Missing: madatory data missing',
  abnormalTunnelStatus: 'Abnormal Tunnel Status >= 1 Hour',
  abnormalTunnelStatusTab: 'Abnormal Tunnel Status',
  statusCode: 'Status Code',
  statusMessage: 'Status Message',
  abnormalTunnelHeartbeatStatus: 'Abnormal Tunnel Heartbeat Status >= 1 Hour',
  abnormalTunnelHeartbeatStatusTab: 'Abnormal Heartbeat',
  duration: 'Duration',
  byCartonByUnit: 'By Carton & By Unit',
  byCarton: 'By Carton',
  byUnit: 'By Unit',
  kpi: 'KPI',
  epcQty: 'EPC Qty',
  statusCode11: 'Status Code = 11: Tunnel Machine Heartbeat Abnormal',
  statusCode12: 'Status Code = 12: Tunnel Machine No Heartbeat Info',
  rfidDailyReport: 'RFID Daily Report',
  reportTitle: 'RFID Tunnel Abnormal Report',
  searchDateTitle: 'Date'
}
